import { render, staticRenderFns } from "./NAPSIMM.vue?vue&type=template&id=2113501e&scoped=true&"
import script from "./NAPSIMM.vue?vue&type=script&lang=js&"
export * from "./NAPSIMM.vue?vue&type=script&lang=js&"
import style0 from "./NAPSIMM.vue?vue&type=style&index=0&id=2113501e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2113501e",
  null
  
)

export default component.exports